import { render, staticRenderFns } from "./NewsletterAdd.vue?vue&type=template&id=2f3d24b0&"
import script from "./NewsletterAdd.vue?vue&type=script&lang=js&"
export * from "./NewsletterAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports